import { createCallchainHttp } from './callchain-http.js'

let http = null

export function configureStoryFilmPromptPackHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/visual-game/admin' })
}

function client() {
  if (http === null) throw new Error('configureStoryFilmPromptPackHttp must be called before story film prompt pack API use')
  return http
}

export async function listPromptPacks(query) {
  return client().get('/story-film/prompt-packs', { query, routeId: 'visualGame.storyFilmPromptPacks.list' })
}

export async function getPromptPack(id) {
  return client().get(`/story-film/prompt-packs/${encodeURIComponent(id)}`, { routeId: 'visualGame.storyFilmPromptPacks.detail' })
}

export async function listStoryFilmExecutions(query = {}) {
  return client().get('/story-film/executions', { query, routeId: 'visualGame.storyFilmExecution.list' })
}

export async function getStoryFilmExecution(id) {
  return client().get(`/story-film/submissions/${encodeURIComponent(id)}/execution`, { routeId: 'visualGame.storyFilmExecution.detail' })
}

export async function listStoryFilmAgentPreparations(query = {}) {
  return client().get('/story-film/agent-preparations', { query, routeId: 'visualGame.storyFilmAgentPreparation.list' })
}

export async function getStoryFilmAgentPreparation(id) {
  return client().get(`/story-film/agent-preparations/${encodeURIComponent(id)}`, { routeId: 'visualGame.storyFilmAgentPreparation.detail' })
}

export async function getStoryFilmPreparationSample(id) {
  return client().getBlob(`/story-film/agent-preparations/${encodeURIComponent(id)}/internal-sample`, { routeId: 'visualGame.storyFilmAgentPreparation.internalSample' })
}

export async function getStoryFilmPreparationReference(id, index) {
  return client().getBlob(`/story-film/agent-preparations/${encodeURIComponent(id)}/references/${encodeURIComponent(index)}`, { routeId: 'visualGame.storyFilmAgentPreparation.reference' })
}

export async function listStoryFilmAgentRevisions(id) {
  return client().get(`/story-film/agent-preparations/${encodeURIComponent(id)}/revisions`, { routeId: 'visualGame.storyFilmAgentRevision.list' })
}

export async function getStoryFilmAgentRevision(id, revision) {
  return client().get(`/story-film/agent-preparations/${encodeURIComponent(id)}/revisions/${encodeURIComponent(revision)}`, { routeId: 'visualGame.storyFilmAgentRevision.detail' })
}

export async function getStoryFilmAgentRevisionReference(id, revision, segment, reference) {
  return client().getBlob(`/story-film/agent-preparations/${encodeURIComponent(id)}/revisions/${encodeURIComponent(revision)}/segments/${encodeURIComponent(segment)}/references/${encodeURIComponent(reference)}`, { routeId: 'visualGame.storyFilmAgentRevision.reference' })
}

export async function getStoryFilmAgentRevisionFilm(id, revision) {
  return client().getBlob(`/story-film/agent-preparations/${encodeURIComponent(id)}/revisions/${encodeURIComponent(revision)}/media`, { routeId: 'visualGame.storyFilmAgentRevision.film' })
}

export async function getStoryFilmAgentRevisionMedia(id, revision, segment) {
  return client().getBlob(`/story-film/agent-preparations/${encodeURIComponent(id)}/revisions/${encodeURIComponent(revision)}/segments/${encodeURIComponent(segment)}/media`, { routeId: 'visualGame.storyFilmAgentRevision.media' })
}

export async function getStoryFilmExecutionReference(id, shot, ref) {
  return client().getBlob(`/story-film/submissions/${encodeURIComponent(id)}/execution/shots/${encodeURIComponent(shot)}/references/${encodeURIComponent(ref)}`, { routeId: 'visualGame.storyFilmExecution.reference' })
}

export async function getStoryFilmExecutionMedia(id) {
  return client().getBlob(`/story-film/submissions/${encodeURIComponent(id)}/execution/media`, { routeId: 'visualGame.storyFilmExecution.media' })
}

export async function approvePromptPack(id, body = {}) {
  return client().post(`/story-film/prompt-packs/${encodeURIComponent(id)}/approve`, { body, routeId: 'visualGame.storyFilmPromptPacks.approve' })
}

export async function rejectPromptPack(id, body) {
  return client().post(`/story-film/prompt-packs/${encodeURIComponent(id)}/reject`, { body, routeId: 'visualGame.storyFilmPromptPacks.reject' })
}

export async function regeneratePromptPack(id, body = {}) {
  return client().post(`/story-film/prompt-packs/${encodeURIComponent(id)}/regenerate`, { body, routeId: 'visualGame.storyFilmPromptPacks.regenerate' })
}
